import ManCrossHeatmapPage from './ManCrossHeatmapPage';

// ── Estilos de celda IPRA (semáforo: 65 / 75 / 85) ───────────────────────────

const getCellStyle = (score) => {
    if (score == null || !Number.isFinite(score)) return { bg: '#F4F8FE', text: '#617993' };
    if (score < 65) return { bg: '#FFE5E5', text: '#F3202A' };
    if (score < 75) return { bg: '#FFF0D6', text: '#F48732' };
    if (score < 85) return { bg: '#FFF8D6', text: '#856404' };
    return              { bg: '#E8F8F0', text: '#62C190' };
};

const getBadgeStyle = (score) => {
    if (score == null || !Number.isFinite(score)) return { bg: '#617993', text: '#fff' };
    if (score < 65) return { bg: '#F3202A', text: '#fff' };
    if (score < 75) return { bg: '#F48732', text: '#fff' };
    if (score < 85) return { bg: '#D4AC0D', text: '#574400' };
    return              { bg: '#62C190',  text: '#fff' };
};

const buildFooter = (areaRows) => {
    if (!areaRows.length) return '';
    const worst = areaRows[0];
    if (!worst.name) return '';
    return `${worst.name} necesita intervención en todas sus dimensiones — no es una falla puntual, es un problema sistémico de liderazgo.`;
};

// ── Config IPRA (objeto estable fuera del componente) ─────────────────────────

const IPRA_HEATMAP_CONFIG = {
    title:            'Riesgo por Área',
    subtitle:         'Mapa de Liderazgo IPRA',
    promLabel:        'IPRA PROM.',
    scoreLabel:       'IPRA',
    calloutThreshold: 75,
    deficitLabel:     'liderazgo',
    noteSuffix:       'del IPRA total',
    getCellStyle,
    getBadgeStyle,
    buildFooter,
};

// ── Componente ────────────────────────────────────────────────────────────────

const ManCrossPageHeatmapIPRA = ({ reportData, headerText, pageNumber }) => (
    <ManCrossHeatmapPage
        headerText={headerText}
        pageNumber={pageNumber}
        totals={reportData?.payload?.totals?.ipra || {}}
        byAreaAndDim={reportData?.payload?.ipra_by_area_and_dimension || {}}
        config={IPRA_HEATMAP_CONFIG}
    />
);

export default ManCrossPageHeatmapIPRA;

